<template>
  <WaggonInfoBody
    :color="workpackage.color"
    :info_box="wallet || $vuetify.breakpoint.smAndDown?false:true"
    :wallet="wallet"
    >
    <template #dialogs>
      <transition name="image">
        <router-view/>
      </transition>
    </template>
    <template #body-content>
      <div :style="`color:${workpackage.textcolor}`">{{$t('Project.Workpackage.Images.Header')}} ({{workpackage.tworkpackageimages.length}})</div>
      <StandardFlexBox
        id="images"
        direction="column"
        height="calc(100% - 40px)"
        :no_wrap="true"
        >
        <StandardDataField
          v-for="file in getUObjects({type: 'tworkpackageimages', ids: workpackage.tworkpackageimages})"
          :key="file.id"
          :file_src="file.image"
          :file_type="file.type"
          :file_extension="file.extension"
          :header="`${file.user} ${file.created.substring(0, 19)}`"
          :value="file.comment"
          :readonly="true"
          :append_icon="hasProjectPermission({project_id: project_id, ppermission: 'Delete Image Work Packages'})?'delete':''"
          @clickAppendIcon="deleteTWorkPackageFile({
            project_id: project_id,
            train_id: train_id,
            taktarea_id: taktarea_id,
            twaggon_id: twaggon_id,
            twork_package_id: tworkpackage_id,
            file_id: file.id,
            index: index
            })"
          append_icon_2="cloud_download"
          @clickAppendIcon2="downloadFile(file.image, workpackage.name, file.extension)"
          width="100%"
          @clickImage="$router.push({
            name: wallet?'ProjectWalletWorkPackageImagesZoomImage':'TaktPlanWorkPackageImagesZoomImage',
            params: {
              image_id: file.id
            },
            })"
          />
          <!-- add image -->
        <StandardDataField
          v-if="
          hasProjectPermission({
            project_id: project_id,
            ppermission: 'Update Work Packages'
            }) ||
          getOwnTWorkPackages(project_id).includes(tworkpackage_id)
          "
          style="position: sticky; position: -webkit-sticky; bottom: 4px"
          :key="update_key_add_image"
          line_height="30px"
          color="grey darken-3"
          text_color="white"
          :header="new_image.name"
          :value="new_image.comment"
          append_icon="send"
          placeholder="add comment"
          width="100%"
          @changeValue="new_image.comment = $event"
          @clickAppendIcon="uploadWorkpackageImage()"
          >
          <template #prepend-slot>
            <v-icon
              v-if="!new_image.file"
              class="ml-1 mr-1"
              @click="$refs.addWorkpackageImage.click()"
              >
              attach_file
            </v-icon>
            <v-img
              class="standard-data-image-preview"
              v-else-if="new_image.type == 'image'"
              :src="new_image.local_url"
              height="34px"
              width="47px"
              contain
              @click="$refs.addWorkpackageImage.click()"
              />
            <div
              v-else
            >
              <v-icon
              :size="30"
              >
              insert_drive_file
            </v-icon>
            {{new_image.extension}}
            </div>
            <input
              v-show="false"
              ref="addWorkpackageImage"
              type="file"
              @change="selectWorkpackageImage($refs.addWorkpackageImage.files[0])"
              >
          </template>
        </StandardDataField>
      </StandardFlexBox>
    </template>
  </WaggonInfoBody>
</template>
<script>
import store from '@/store/index'
import { WaggonInfoMixin } from '@/mixins/WaggonInfo.mixin.js'

export default {
  props: ['project_id', 'train_id', 'taktarea_id', 'twaggon_id', 'tworkpackage_id', 'workpackage', 'wallet'],
  mixins: [
    WaggonInfoMixin
  ],
  beforeRouteEnter(to, from, next) {
    // store.dispatch('TWorkPackageImage/requestTWorkPackageImages', {
    //     project_id: to.params.project_id,
    //     train_id: to.params.train_id,
    //     taktarea_id: to.params.taktarea_id,
    //     twaggon_id: to.params.twaggon_id,
    //     twork_package_id: to.params.tworkpackage_id
    //   })
    //   .then(() => {
    //     next();
    //   });
    store.dispatch('Ultra/requestUObject', {
      url: [
        {projects: to.params.project_id},
        {trains: to.params.train_id},
        {taktareas: to.params.taktarea_id},
        {twaggons: to.params.twaggon_id},
        {tworkpackages: to.params.tworkpackage_id},
        {tworkpackageimages: ''},
        {showWithEntitiesNormalized: ''}
      ],
      add_u_object: true
    }).then(() => {
      next();
    })
  },
  mounted() {
    var element = document.getElementById("images");
    if (element) {
      element.scrollTop = element.scrollHeight;
    }
  },
  watch: {
    'workpackage.tworkpackageimages': function() {
      setTimeout(function () {
        var element = document.getElementById("images");
        element.scrollTop = element.scrollHeight;
      }, 10);
    },
  }
}
</script>
<style>
  div {
    user-select: none;
  }
  .image-enter, .image-leave-to {
    transform: translateY(100vh);
  }
  .image-enter-active, .image-leave-active {
    transition: transform 0.2s ease-in-out;
  }
  .file-box {
    /* height: 34px; */
    width: 47px;
    display: inline-block;
  }
</style>
